// === Admin API Client Hook ===
// Centralized, consistent API access for all admin pages.
// Returns a typed API client with automatic auth, error handling, and env vars.

import { useMemo } from 'react';
import { createApiClient } from '@click2gro/api-client';
import { useAuth } from './auth';

export function useAdminApi() {
  const { session } = useAuth();

  return useMemo(() => {
    const baseUrl = (import.meta.env['VITE_API_URL'] as string | undefined) ?? 'http://localhost:8787';

    return createApiClient({
      baseUrl,
      getToken: async () => session?.access_token ?? null,
    });
  }, [session?.access_token]);
}
